"use strict";
/**
 * HTTP client primitives: fetch wrapper, error class, paginated GET.
 *
 * Auth headers are intentionally NOT imported here — callers inject a
 * `getHeaders` function so each platform (web / mobile) supplies its own
 * storage-backed implementation.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataWithPagination = exports.getData = exports.fetchWithTimeout = exports.ApiError = void 0;
// ─── Error class ──────────────────────────────────────────────────────────────
class ApiError extends Error {
    constructor(message, statusCode, originalError) {
        super(message);
        this.statusCode = statusCode;
        this.originalError = originalError;
        this.name = 'ApiError';
    }
}
exports.ApiError = ApiError;
// ─── Fetch with timeout ───────────────────────────────────────────────────────
const fetchWithTimeout = async (url, options = {}, timeout = 30000) => {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    try {
        const res = await fetch(url, { ...options, signal: controller.signal });
        clearTimeout(id);
        return res;
    }
    catch (err) {
        clearTimeout(id);
        if (err.name === 'AbortError') {
            throw new ApiError('Request timeout', 408, err);
        }
        throw new ApiError('Network error', 0, err);
    }
};
exports.fetchWithTimeout = fetchWithTimeout;
// ─── Generic GET ─────────────────────────────────────────────────────────────
const getData = async (url, getHeaders = async () => ({})) => {
    const headers = await getHeaders();
    const res = await (0, exports.fetchWithTimeout)(url, {
        headers: { 'Content-Type': 'application/json', ...headers },
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new ApiError(err.message ?? `HTTP ${res.status}: ${res.statusText}`, res.status);
    }
    return res.json();
};
exports.getData = getData;
// ─── Paginated GET ────────────────────────────────────────────────────────────
const getDataWithPagination = async (url, page = 1, perPage = 10, getHeaders = async () => ({})) => {
    const separator = url.includes('?') ? '&' : '?';
    const fullUrl = `${url}${separator}per_page=${perPage}&page=${page}`;
    const headers = await getHeaders();
    const res = await (0, exports.fetchWithTimeout)(fullUrl, {
        headers: { 'Content-Type': 'application/json', ...headers },
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new ApiError(err.message ?? `HTTP ${res.status}: ${res.statusText}`, res.status);
    }
    const data = await res.json();
    return {
        data,
        total: parseInt(res.headers.get('x-wp-total') ?? '0', 10),
        totalPages: parseInt(res.headers.get('x-wp-totalpages') ?? '0', 10),
        currentPage: page,
    };
};
exports.getDataWithPagination = getDataWithPagination;
//# sourceMappingURL=client.js.map